import { ChangeDetectionStrategy, Component, ElementRef, computed, input, output, viewChild } from '@angular/core';
import { BadgeTypeOld } from '@mwe/models';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-pill-badge',
  templateUrl: './pill-badge.component.html',
  imports: [TranslateDirective, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillBadgeComponent {
  text = input<string>();
  state = input<string>();
  isLast = input<boolean>(false);
  type = input<BadgeTypeOld>();
  closable = input<boolean>(false);
  unselect = output<any>();

  buttonElement = viewChild.required<ElementRef<HTMLElement>>('button');

  labelText = computed(() => 'address-input-pill.' + this.state() + (this.isLast() ? '' : 'Long'));

  remove(event: any): void {
    this.unselect.emit(event);
  }
}
